const INITIAL_STATE = {
  loading: false,
  error: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "USUARIO_DESLOGADO":
    case "UPDATE_CONFIGURACOES_ERRO":
      return { ...state, loading: false, error: action.payload }
    case "UPDATE_CONFIGURACOES_SUCESSO": 
      return { ...state, loading: false, ...action.payload }
    case "INIT_UPDATE_CONFIGURACOES": 
      return { ...state, loading: true }
    case "SET_CONFIG":
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
